import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { AddPartnerNotificationEmailInterface } from '../definitions/add-partner-notification-email.interface';
import { PartnerNotificationEmailAddResponseInterface } from '../definitions/partner-notification-email-add-response.interface';

@Injectable()
export class AddPartnerNotificationEmailService {

  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public partnerEmailNotificationAdd(addPartnerNotificationEmail: AddPartnerNotificationEmailInterface): Observable<PartnerNotificationEmailAddResponseInterface> {
    const url = `${this.configService.config.rest.apiV2Url}/partner-notification-emails`;

    return this.client.post<PartnerNotificationEmailAddResponseInterface>(url, addPartnerNotificationEmail)
    .pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}